// 复用旧 app.js 的 fallbackCopy 逻辑：
// 优先 navigator.clipboard，失败时退到隐藏 textarea + execCommand。
export async function copyText(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // fallthrough
    }
  }
  fallbackCopy(text);
}

function fallbackCopy(text: string): void {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand("copy");
  } catch {
    // ignore
  }
  document.body.removeChild(ta);
}

// 旧 app.js 有个 decodeEntities 工具：把 HTML 实体（&lt; &gt;）还原为字面量。
// 新代码直接用字符串字面量，不会再走 entity 编码，所以不需要。
